import { ApproveInstallationModal } from './approve-installation-modal';
import { RejectInstallationModal } from './reject-installation-modal';

/** Which action overlay the list page has opened (from the row ellipsis or the detail drawer),
 *  and for which row. Minimal shape so both an `InstallationRow` (ellipsis) and an
 *  `InstallationDetail` (drawer) satisfy it structurally — the modals only need orderId +
 *  orderNumber (there is no separate installation-request id; one row per order). */
export type InstallationOverlay = {
  kind: 'approve' | 'reject';
  row: { orderId: string; orderNumber: string };
} | null;

/** Renders the Approve (ticket 08) or Reject (ticket 07) modal for the overlay the list page /
 *  detail drawer opened. `onClose` closes the overlay; `onActioned` also closes the detail drawer
 *  after a successful approve/reject (the mutation already invalidated the list). */
export function InstallationActionModals({
  overlay,
  onClose,
  onActioned,
  onRefused,
}: {
  overlay: InstallationOverlay;
  onClose: () => void;
  onActioned?: () => void;
  /** Forwarded to whichever modal is open: the attempt was refused server-side, so a host with its
   *  own query keys (the Dashboard) must refresh them. */
  onRefused?: () => void;
}) {
  if (!overlay) return null;
  const { kind, row } = overlay;
  return kind === 'reject' ? (
    <RejectInstallationModal
      open
      id={row.orderId}
      onClose={onClose}
      onRejected={() => onActioned?.()}
      onRefused={onRefused}
    />
  ) : (
    <ApproveInstallationModal
      open
      id={row.orderId}
      onClose={onClose}
      onApproved={() => onActioned?.()}
      onRefused={onRefused}
    />
  );
}
